import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`} data-id="element-132">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133">
        <div className="flex justify-between items-center py-4" data-id="element-134">
          {/* Logo */}
          <div className="flex items-center" data-id="element-135">
            <span className="text-2xl font-bold font-outfit text-settl-blue" data-id="element-136">
              Settl
              <span className="text-charcoal text-opacity-80" data-id="element-137">
                by RollingPay
              </span>
            </span>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-138">
            <a href="#how-it-works" className="text-charcoal hover:text-settl-blue transition-colors" data-id="element-139">
              How It Works
            </a>
            <a href="#pricing" className="text-charcoal hover:text-settl-blue transition-colors" data-id="element-140">
              Pricing
            </a>
          </div>
          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-141">
            <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-primary" data-id="element-142">
              Start Free Trial
            </a>
          </div>
          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-143">
            <button onClick={() => setIsOpen(!isOpen)} className="text-charcoal focus:outline-none" data-id="element-144">
              {isOpen ? <XIcon className="h-6 w-6" data-id="element-145" /> : <MenuIcon className="h-6 w-6" data-id="element-146" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-t" data-id="element-147">
          <div className="container mx-auto px-4 py-4 space-y-4" data-id="element-148">
            <a href="#how-it-works" className="block py-2 text-charcoal hover:text-settl-blue" onClick={() => setIsOpen(false)} data-id="element-149">
              How It Works
            </a>
            <a href="#pricing" className="block py-2 text-charcoal hover:text-settl-blue" onClick={() => setIsOpen(false)} data-id="element-150">
              Pricing
            </a>
            <a href="https://wa.me/60127743934/?text=I%20am%20interested%20in%20Settl" className="btn-primary w-full block text-center" data-id="element-151">
              Start Free Trial
            </a>
          </div>
        </div>}
    </nav>;
};
export default Navbar;